import React from "react";

const Address = () => {
  return (
    <>
      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-map position-absolute"></i>
        <span className="d-block">adresse</span>Tizi Ouzou, Algérie
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-envelope-open position-absolute"></i>
        <span className="d-block">email</span>{" "}
        <a href="mailto:bougharebamazigh@yahoo.fr">bougharebamazigh@yahoo.fr</a>
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-phone-square position-absolute"></i>
        <span className="d-block">n° téléphone</span>{" "}
        <a href="Tel: +213 561 27 91 30">+213 561 27 91 30</a>
      </p>
      {/* End .custom-span-contact */}
    </>
  );
};

export default Address;
